module.exports = __webpack_public_path__ + "media/images/corporate-logos/logo-p-g-8ac6e9d9eb3b1956bf6c4105c27a68f9.svg";